<template>
  <div class="about-container">
    <div class="about-box">
      <div class="left animate__animated" :class="addAnimate">
        <div class="title-box "><span class="title">关于我们</span><span class="desc">/AboutUs</span></div>
        <div class="logo-box">
          <span>华艺元界</span>
          <div class="line"></div>
        </div>
        <div class="desc-box">
          华艺元界是&nbsp;金辰宇(天津)科技有限公司&nbsp;旗下，一款结合区块链与元宇宙技术的应用，为用户提供数字资产保护、版权认证及在线展览沉浸式体验。无论是艺术创作、数字收藏还是虚拟探索，这里都是你进入未来数字世界的理想入口。
        </div>
        <div class="data-box">
          <div class="data-item">
            <p class="num">10+</p>
            <p class="desc">计算机软件著作权</p>
          </div>
          <div class="data-item">
            <p class="num">3+</p>
            <p class="desc">专项发明专利</p>
          </div>
          <div class="data-item">
            <p class="num">5+</p>
            <p class="desc">行业协会会员单位</p>
          </div>
          <div class="data-item">
            <p class="num">5+</p>
            <p class="desc">行业标准制定</p>
          </div>
        </div>
      </div>
      <div class="right">
        <img src="~@/assets/imgs/footer-bg2.jpg" alt="">

      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['addAnimate']
}
</script>

<style lang="less" scoped>
@import url('~@/assets/css/reset.css');

.about-container {
  width: 100%;
  height: 100%;
  padding: 0 32px;
  padding-top: 80px;
  box-sizing: border-box;

  .about-box {
    width: 100%;
    height: calc(100% - 120px);
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    box-sizing: border-box;

    .left {
      width: 100%;
      height: auto;
      text-align: start;

      .title-box {
        display: flex;
        width: 100%;
        height: 50px;

        padding-bottom: 20px;

        .title {
          color: #FF793A;
          font-size: 32px;
          font-weight: 700;
        }

        .desc {
          margin-top: 10px;
          font-size: 20px;
          text-indent: .8rem;
          font-weight: 400;
          color: #ACADAE;
        }
      }

      .logo-box {
        width: 100%;
        height: auto;

        span {
          font-size: 32px;
          color: #000;
          font-weight: 700;

        }

        .line {
          width: 80px;
          height: 2px;
          background-color: #FF793A;
          margin-top: 20px;
          margin-bottom: 20px;
          box-sizing: border-box;
        }
      }

      .desc-box {
        width: 100%;
        height: 200px;
        font-size: 16px;
        font-weight: bolder !important;

        line-height: 22px;
        letter-spacing: 2px;
        font-weight: 400;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        /* 限制显示行数 */
        -webkit-box-orient: vertical;
        overflow: hidden;
        box-sizing: border-box;
      }

      .data-box {
        display: flex;
        width: 100%;
        flex-wrap: wrap;
        height: auto;
        padding-top: 20px;
        box-sizing: border-box;

        .data-item {
          width: 45%;
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          border-right: 2px solid #FF793A;

          .num {
            font-size: 32px;
            line-height: 60px;
            color: #FF793A;
          }

          .desc {
            font-size: 16px;
            color: #FF793A;
          }
          &:nth-child(2n) {
            border-right: none;
          }
          &:nth-child(2n-1) {
            margin-bottom: 20px;
          }

          &:last-child {
            border-right: none;
          }

        }

      }

    }

    .right {
      padding-top: 20px;
      width: 100%;
      height: auto;
      padding-bottom: 20px;
      box-sizing: border-box;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

    }

  }

  .footer {
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 120px;
    padding: 0 80px;
    background-color: #FAFAFA;
    color: #8c9198;

    box-sizing: border-box;

    .logo-box {
      width: max-content;
      height: 100%;

      .logo {
        width: 100%;
        height: 50px;
        display: flex;
        align-items: center;

        span {
          line-height: 20px;
          text-indent: 1rem;
          color: #000;
        }
      }

      .license {
        width: 100%;
        height: 25px;
        font-size: 14px;
        color: #8c9198;
        text-align: start;
      }
    }

    .about-hy {
      width: auto;
      height: 100%;

      span {
        display: block;
        width: 100%;
        line-height: 50px;
        color: #000;
      }

      li {
        display: block;
        width: auto;
        height: 20px;
        font-size: 12px;

        a:hover {
          color: #000;
        }
      }
    }

    .about-flow {
      width: auto;
      height: 100%;

      span {
        display: block;
        width: 100%;
        line-height: 50px;
        color: #000;
      }

      li {
        display: block;
        width: auto;
        height: 20px;
        font-size: 12px;

        a:hover {
          color: #000;
        }
      }
    }
  }

}
</style>